import React, { useEffect, useState } from "react";
import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function StickyCall() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [setVisible]);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t-2 border-[#D32F2F] transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <a
        href={`tel:${BUSINESS.phoneDial}`}
        data-testid="sticky-call-btn"
        className="flex items-center justify-center gap-2 bg-[#D32F2F] text-white font-semibold py-4 pulse-call"
      >
        <Phone className="w-5 h-5" strokeWidth={2.5} />
        Call Now
      </a>
      <a
        href="#contact"
        data-testid="sticky-schedule-btn"
        className="flex items-center justify-center gap-2 bg-[#0B132B] text-white font-semibold py-4"
      >
        <CalendarCheck className="w-5 h-5" strokeWidth={2.5} />
        Schedule
      </a>
    </div>
  );
}
